import { useMemo, useState } from "react";
import MenuFrame from "./frames/menu_frame";
import { useLanguage } from "./LanguageContext";
import TrayItem from "./frames/tray_item";

const NewDashboard = () => {
    const { text } = useLanguage();

    const apps = useMemo(
        () => [
            { name: text("counter_booking"), description: "Consignment booking at outlet counter", image: "/img/desk1.png", link: "/desk-booking" },
            { name: text("corporate_booking"), description: "Corporate client consignment booking", image: "/img/booking.png", link: "/org-booking" },
            { name: text("pickup"), description: "Corporate client consignment pickup", image: "/img/pickup2.png", link: "/pickup-booking" },
            { name: text("packaging"), description: "Corporate client consignment packaging", image: "/img/packaging.png", link: "/packaging-booking" },
            { name: text("insurance"), description: "Insurance service by DTDC Express", image: "/img/insurance.png", link: "/insurance" },
            { name: text("correction"), description: "Edit consignment details for Corporate and Desk", image: "/img/edit3.png", link: "/correction/home" },
            { name: text("billing"), description: "Corporate billing and invoice genration", image: "/img/invoice1.png", link: "/billing" },
            { name: text("invoices"), description: "Invoice list and operations", image: "/img/invoice.png", link: "/invoices" },
            { name: text("accounts"), description: "FinOps account management tool", image: "/img/accounts1.png", link: "/accounts" },
            { name: text("users"), description: "User access management", image: "/img/user.png", link: "/users" },
            { name: text("employee"), description: "Employee resource management", image: "/img/employee.png", link: "/employee" },
            { name: text("clients"), description: "Client resource management", image: "/img/company2.png", link: "/client" },
            { name: text("vendor"), description: "Vendor resource management", image: "/img/company1.png", link: "/vendor" },
            { name: text("quotation"), description: "Create quotation for client", image: "/img/quote.png", link: "/quotation" },
            { name: text("finops"), description: "Financial operations and GST", image: "/img/finops.png", link: "/fin-ops" },
            { name: text("admin"), description: "Admin settings and security", image: "/img/settings.png", link: "/admin" },
            { name: text("inventory"), description: "Consignment inventory", image: "/img/inventory.png", link: "/inventory" },
            { name: text("reports"), description: "Finance report and analysis", image: "/img/report1.png", link: "/reports" },
            { name: text("letter_head"), description: "DTDC letter head", image: "/img/seal.png", link: "/latter-head" },
            { name: text("excel"), description: "Spreadsheet operations", image: "/img/finops.png", link: "/fin-ops/excel" },
            // { name: "Receivable", description: "", image: "/img/receivable.png", link: "/receivable" },
            // { name: "External Links", description: "List of external link", image: "/img/link.png", link: "/external-links" },
        ],
        [text]
    );

    const [appList, setAppList] = useState(apps);

    const gradients = [
        ["#5B86E5", "#36D1DC"],
        ["#8E2DE2", "#4A00E0"],
        ["#00C9A7", "#92FE9D"],
        ["#FC5C7D", "#6A82FB"],
        ["#FF9966", "#FF5E62"],
        ["#4FACFE", "#00F2FE"],
        ["#43CEA2", "#185A9D"],
        ["#F7971E", "#FFD200"],
    ];

    const handleSearch = (e) => {
        const value = e.target.value.trim().toLowerCase();
        if (!value) {
            setAppList(apps);
            return;
        }
        setAppList(apps.filter((item) => item.name.toLowerCase().includes(value) || item.description.toLowerCase().includes(value)));
    };

    return (
        <MenuFrame onSearch={handleSearch} screen="DASHBOARD">
            <TrayItem items={appList} gradients={gradients} title={text("enterprise_dashboard")} subtitle={text("enterprise_dashboard_subtitle")} />
        </MenuFrame >
    );
};

export default NewDashboard;